export default "__VITE_ASSET__Fb0dpNl4__"